import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "@mtm/components";
import styles from "./ManageTrustedContactsComponent.module.scss";
import CommonStyles from "../ManageServiceUsersComponent/ManageServiceUsersComponent.module.scss";
import "antd/dist/antd.css";
import defaultUserPhoto from "../../assets/images/userIcon.svg";
import DeleteIcon from "../../assets/images/blueCircleDeleteIcon.svg";
import EditIcon from "../../assets/images/blueCircleEditIcon.svg";
import { PersonSummary, ServiceUserData } from "../../types/ApplicationTypes";
import {
  UpsertTrustedContactDetails,
  getLookupListByListName,
  getTrustedContactsByPersonId,
} from "../../services/RegistrationService";
import TrustedContacts from "../TrustedContacts/TrustedContacts";
import { DefaultTCData, TrustedContact } from "../../types/PersonTypes";
import EllipsisText from "../../helpers/EllipsisText/EllipsisText";
import CustomButton from "../../common/Buttons/CustomButton";
import { backArrowIcon } from "../../assets/images";
import { notification } from "antd";

type Props = {
  personId: number;
  userFirstName: string;
};

const defaultValues = {
  personId: 0,
  firstName: "",
  whoWillUseServices: "",
};

const ServiceDefaultValues = {
  serviceUserPersonId: 0,
  registeredEmail: "",
  serviceUserFirstName: "",
  routingPage: "",
  CCPDetailsId: 0,
  serviceUsersStatus: true,
};

function ManageTrustedContactsComponent({ personId, userFirstName }: Props) {
  const [data, setData] = useState<TrustedContact[]>([]);
  const [tcVisible, setTCVisible] = useState<boolean>(false);
  const [personDataForTC, setPersonDataForTC] = useState<PersonSummary>(
    defaultValues
  );
  const [reloadTCData, setReloadTCData] = useState<boolean>(false);
  const [editData, setEditData] = useState<TrustedContact>(DefaultTCData);
  const [editTC, setEditTC] = useState<boolean>(false);
  const [makeTCEdit, setMakeTCEdit] = useState<boolean>(false);
  const [serviceUserInfo, setServiceUserInfo] = useState<ServiceUserData>(
    ServiceDefaultValues
  );
  const [tcDeleteVisible, setTCDeleteVisible] = useState<boolean>(false);
  const [addTC, setAddTC] = useState<boolean>(false);
  const fName: string = userFirstName.split(" ")[0];

  useEffect(() => {
    if (personId > 0 || reloadTCData) {
      getTrustedContacts(personId);
      setReloadTCData(false);
    }
  }, [personId, reloadTCData]);

  async function getTrustedContacts(personId: number) {
    const trustedContacts = await getTrustedContactsByPersonId(personId);
    let relationshipVal = await getLookupListByListName(
      1,
      "TrustedContactRelationships"
    );
    relationshipVal.map(
      (x: { itemId: string }) => (x.itemId = x.itemId.toString())
    );

    let sampleData: TrustedContact[] = [];
    let order: number = 0;
    trustedContacts.map((item: any) => {
      let name = relationshipVal.find(
        (x: { itemId: string }) => x.itemId === item.relationship.toString()
      );
      item.relationshipName = name.itemName;
      let mobile = item.phone.replace(/[^\d]/g, "");
      item.phone = mobile.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      item.order = order + 1;
      sampleData.push(item);
      order++;
    });
    setData(sampleData);

    const personData = {
      personId: personId,
      firstName: userFirstName,
      whoWillUseServices: "ProfileTC",
    };
    setPersonDataForTC(personData);
  }

  function handleAddTrustedContact() {
    setTCVisible(true); //for modal popup
    setMakeTCEdit(false); // for edit TC
    setAddTC(true); // for add TC
  }

  function handleEditTrustedContact(data: TrustedContact) {
    data.relationship = data.relationship.toString();
    setEditData(data);
    setMakeTCEdit(true);
    setEditTC(true);
    setTCVisible(true);
    setAddTC(false);
  }

  function deleteTrustedContactsHandler(deleteTC: any) {
    deleteTC.isActive = false;
    deleteTC.relationship = Number(deleteTC.relationship);
    setEditData(deleteTC);
    setTCDeleteVisible(true);
  }

  async function removeTrustedContact() {
    try {
      const tcData = {
        personId: Number(personId),
        trustedContact: [editData],
      };
      await UpsertTrustedContactDetails(tcData);
      setTCDeleteVisible(false);
      setReloadTCData(true);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to get PersonAttributesKey for a Caregiver.",
      });
    }
  }

  function handleRemoveTrustedContact() {
    setTCDeleteVisible(true);
  }

  function handleCancel() {
    setTCDeleteVisible(false);
  }
  const handleBack = () => {
    window.history.back();
  };

  return (
    <>
      <div className="mobile-container">
        <Row>
          <Col xs={24} lg={0}>
            <Row justify="start" gutter={[0, 25]}>
              <Col span={24}>
                <CustomButton
                  text="Back"
                  handlerFunction={handleBack}
                  type="link"
                  icon={backArrowIcon}
                  className="backBtn"
                />
              </Col>
              <Col span={24} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs="24" lg={0}>
            <span>
              <b>{userFirstName}</b>
            </span>
            <h3>Trusted Contacts</h3>
          </Col>
        </Row>

        <div className="trustedContactTxt">
          Trusted contacts will receive communication about <b>{fName}'s</b>{" "}
          transportation & other services.
        </div>

        {data?.length > 0 && (
          <Row>
            <Col xs={0} lg={24}>
              <Row
                justify="start"
                className=" table-head text-left"
                gutter={[50, 16]}
              >
                <Col span="5">Contact Name</Col>
                <Col span="4">Relationship</Col>
                <Col span="5">Phone Number</Col>
                <Col span="4">Email</Col>
                <Col span="4"></Col>
              </Row>
            </Col>
          </Row>
        )}
        {data?.length === 0 ? (
          <p className={CommonStyles.ErrorMessage + " subTextFont "}>
            No trusted contacts have been added.
          </p>
        ) : (
          <div>
            {data?.map((val: any) => {
              return (
                <>
                  <Row>
                    <Col xs={0} lg={24}>
                      <Row gutter={[0, 20]}>
                        <Col span={24} />
                        <Col span={24}>
                          <Row
                            justify="start"
                            className=" table-body text-left"
                            gutter={[50, 16]}
                            key={val.order}
                          >
                            <Col span="5">
                              <EllipsisText
                                text={`${val.firstName} ${val.lastName}`}
                                maxVisibleTextLength={10}
                              />
                            </Col>
                            <Col span="4">{val.relationshipName}</Col>
                            <Col span="5">{val.phone}</Col>
                            <Col span="4">
                              <EllipsisText
                                text={val.email}
                                maxVisibleTextLength={10}
                              />
                            </Col>
                            <Col span="4">
                              <img
                                alt="EditTC"
                                className={CommonStyles.ContactsIconSize}
                                src={EditIcon}
                                onClick={() => handleEditTrustedContact(val)}
                              />
                              <img
                                alt="DeleteTC"
                                className={CommonStyles.ContactsIconSize}
                                src={DeleteIcon}
                                onClick={() =>
                                  deleteTrustedContactsHandler(val)
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24} lg={0}>
                      <Row
                        className={styles.trustedContactDetails}
                        justify="center"
                        align="middle"
                        key={val.order}
                      >
                        <Col span={4}>
                          <Row justify="center">
                            <Col>
                              <img
                                src={defaultUserPhoto}
                                className={styles.defaultUserPhotoSize}
                                alt="default-user-photo"
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col span={14}>
                          <Row>
                            <Col span={24} className={styles.tcName}>
                              <EllipsisText
                                text={`${val.firstName} ${val.lastName}`}
                                maxVisibleTextLength={20}
                              />
                            </Col>
                            <Col className={styles.tcDetails} span={24}>
                              {val.relationshipName}
                            </Col>
                            <Col className={styles.tcDetails} span={24}>
                              {val.phone}
                            </Col>
                            <Col className={styles.tcDetails} span={24}>
                              <EllipsisText
                                text={val.email}
                                maxVisibleTextLength={20}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          <Row justify="center" gutter={[10, 0]}>
                            <Col>
                              <img
                                alt="EditTC"
                                src={EditIcon}
                                onClick={() => handleEditTrustedContact(val)}
                              />
                            </Col>
                            <Col>
                              <img
                                alt="DeleteTC"
                                src={DeleteIcon}
                                onClick={() =>
                                  deleteTrustedContactsHandler(val)
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              );
            })}
          </div>
        )}
        <Row gutter={[0, 23]}>
          <Col span={24} />
          <Col>
            {data.length < 5 && (
              <CustomButton
                text="+ Add New"
                type="link"
                handlerFunction={() => handleAddTrustedContact()}
                className="hyperLinkBtn"
              />
            )}
          </Col>
        </Row>
        <div>
          <Modal
            handleSuccess={handleAddTrustedContact}
            visible={tcVisible}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            className={CommonStyles.tcModalWidth}
          >
            <TrustedContacts
              personSummary={personDataForTC}
              serviceUserInfo={serviceUserInfo}
              pageType={undefined}
              setPageType={undefined}
              isCallFromDashboard={true}
              addTC={addTC}
              setTCVisible={setTCVisible}
              setReloadTCData={setReloadTCData}
              editData={editData}
              isEditTC={editTC}
              setEditTC={setEditTC}
              isTCEditFromDashboard={makeTCEdit}
              setMakeTCEdit={setMakeTCEdit}
              isTcModal={true}
            />
          </Modal>
          <Modal
            handleSuccess={handleRemoveTrustedContact}
            visible={tcDeleteVisible}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            className={CommonStyles.modalDeleteWidth}
          >
            <div className={CommonStyles.modalDeleteHeading}>
              Remove Trusted Contact
            </div>
            <div className={CommonStyles.modalDeleteText + " subTextFont "}>
              Are you sure you want to remove{" "}
              <b>{editData.firstName + " " + editData.lastName}</b> as a Trusted
              Contact?
            </div>
            <div className={CommonStyles.modalDeleteBtns}>
              <Button
                clickHandler={handleCancel}
                className={CommonStyles.modalDeleteBtnCancel}
                key="close"
              >
                Cancel
              </Button>
              <Button
                clickHandler={removeTrustedContact}
                className={CommonStyles.modalDeleteBtnSave}
                key="close"
              >
                Yes, Remove
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default ManageTrustedContactsComponent;
